<template>
    <div class="tracking-content mb-3">
        <status-header-component
            :delivered="statuses.delivered.includes(tracking.original_status)"
            :trackingNumber="trackingNumber"
            :trackingStatus="tracking.status"
            :estimatedDelivery="tracking.estimated_delivery"
        ></status-header-component>
        <div class="toggle-content p-0">
            <div class="bottom-packet-row">
                <div class="packet-info tracking-info w-100">
                    <div style="width: 25%" class="status-block">
                        <div class="d-flex justify-content-center">
                            <i class="fa fa-check tracking-status-icon-check" aria-hidden="true" v-if="inclusiveStatuses.waiting.includes(tracking.original_status)"></i>
                            <i class="tracking-status-icon-circle-not-active" aria-hidden="true" v-else></i>
                        </div>
                        <div :class="'d-flex justify-content-center tracking-status-decs' + (inclusiveStatuses.ready.includes(tracking.original_status) ? '-active' : '')">
                            <p>{{ $helper.trans('Ticket_ready') }}</p>
                        </div>
                    </div>
                    <div style="width: 25%" class="status-block">
                        <div class="d-flex justify-content-center">
                            <i class="fa fa-check tracking-status-icon-check" aria-hidden="true" v-if="inclusiveStatuses.inTransit.includes(tracking.original_status)"></i>
                            <i class="tracking-status-icon-circle-not-active" aria-hidden="true" v-else></i>
                        </div>
                        <div :class="'d-flex justify-content-center tracking-status-decs' + (inclusiveStatuses.ready.includes(tracking.original_status) ? '-active' : '')">
                            <p>{{ $helper.trans('Package_picked_up') }}</p>
                        </div>
                    </div>
                    <div style="width: 25%" class="status-block">
                        <div class="d-flex justify-content-center">
                            <i class="fa fa-check tracking-status-icon-check" aria-hidden="true" v-if="inclusiveStatuses.delivered.includes(tracking.original_status)"></i>
                            <i class="tracking-status-icon-circle-not-active" aria-hidden="true" v-else></i>
                        </div>
                        <div :class="'d-flex justify-content-center tracking-status-decs' + (inclusiveStatuses.inTransit.includes(tracking.original_status) ? '-active' : '')">
                            <p>{{ $helper.trans('In_transit') }}</p>
                        </div>
                    </div>
                    <div style="width: 25%">
                        <div class="d-flex justify-content-center">
                            <i class="fa fa-check tracking-status-icon-check" aria-hidden="true" v-if="inclusiveStatuses.delivered.includes(tracking.original_status)"></i>
                            <i class="tracking-status-icon-circle-not-active" aria-hidden="true" v-else></i>
                        </div>
                        <div :class="'d-flex justify-content-center tracking-status-decs' + (inclusiveStatuses.delivered.includes(tracking.original_status) ? '-active' : '')">
                            <p>{{ $helper.trans('Delivered') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <parcel-component
            v-for="(parcel, parcelIndex) in tracking.packages" 
            :key="parcelIndex"
            :parcel="parcel"
            :tracking="tracking"
            :statuses="statuses"
            :index="parcelIndex"
            :trackingNumber="trackingNumber"
        ></parcel-component>
    </div>
</template>
<script>
export default {
    props: {
        tracking: {
            type: Object,
            required: true,
        },
        trackingNumber: {
            type: String,
            required: true,
        },
        statuses: {
            type: Object,
            required: true,
        },
        inclusiveStatuses: {
            type: Object,
            required: true,
        },
    },
}
</script>
